module.exports = __webpack_public_path__ + "static/media/honda-vial.b2b58a9e.svg";